/*eslint-disable @typescript-eslint/no-unsafe-member-access*/
/*eslint-disable @typescript-eslint/no-floating-promises*/
import React from 'react';
import { useEffect } from 'react';

import { Alert } from 'src/common/components/Alert';

import { fetchLegalEntities } from './api';
import { List, LegalEntityFilter } from './components';
import { LegalEntityListContext } from './context';
import { useActions } from './useActions';

const LegalEntityList: React.FC = () => {
  const { state, dispatch, ...actions } = useActions();
  const { setLegalEntities, setLoadingLegalEntities } = actions;
  const { legalEntities, search, currentPage, error } = state;

  const getLegalEntities = (): void => {
    setLoadingLegalEntities(true);
    fetchLegalEntities(search, currentPage)
      .then((result) => {
        setLegalEntities(result.data.results, result.data.count);
      })
      .catch(() => {
        setLegalEntities([], 0, 'An error occurred while loading legal entities.');
      })
      .finally(() => {
        setLoadingLegalEntities(false);
      });
  };

  useEffect(getLegalEntities, [currentPage, search, setLegalEntities, setLoadingLegalEntities]);

  return (
    <LegalEntityListContext.Provider value={{ state, dispatch, actions }}>
      <div className="flex flex-col p-8" style={{ height: 'calc(100vh - 66px)' }}>
        <h2 className="sm:px-0 px-4 pb-4">Legal Entities</h2>
        <LegalEntityFilter />
        {!!error && (
          <Alert className="mb-6" type="error">
            {error}
          </Alert>
        )}
        {!error && <List legalEntities={legalEntities} refetch={getLegalEntities} />}
      </div>
    </LegalEntityListContext.Provider>
  );
};

export default LegalEntityList;
